export default __webpack_public_path__ + "static/media/AlanJarry.5856f8f8.png";